import { Component, computed, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FlowActionPanelAction } from '../enums';
import { FlowDispatchEvent } from '../models/flow-dispatch-event.model';
import { BaseFlowNode } from '../models/flow-node.model';
import { ViewPort, ViewPortType } from '../models/flow-port.model';

@Component({ changeDetection: ChangeDetectionStrategy.Eager, template: '' })
export abstract class FlowAbstractNodeComponent<TNode extends BaseFlowNode<TData>, TData> {
  node = input.required<TNode>();
  id = computed(() => this.node()?.id);
  label = computed(() => this.node()?.label as string);
  type = computed(() => this.node()?.type);
  data = computed(() => this.node()?.data);
  inputs = computed(() => this.node()?.ports?.filter((port: ViewPort) => port.type === ViewPortType.INPUT));
  outputs = computed(() => this.node()?.ports?.filter((port: ViewPort) => port.type === ViewPortType.OUTPUT));
  dispatchEvent = output<FlowDispatchEvent>();

  removeNode(options?: any) {
    this.dispatchEvent.emit({ type: FlowActionPanelAction.REMOVE_NODE, node: this.node(), options });
  }

  editNode(options?: any) {
    this.dispatchEvent.emit({ type: FlowActionPanelAction.EDIT_NODE, node: this.node(), options });
  }
}
